import script from "./BlueChoice.vue?vue&type=script&setup=true&lang=js"
export * from "./BlueChoice.vue?vue&type=script&setup=true&lang=js"

import "./BlueChoice.vue?vue&type=style&index=0&id=17b948c7&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-17b948c7"]])

export default __exports__